module.exports = __webpack_public_path__ + "static/wave-4b3085c701c0eef8292d5f411638f02d.svg";